import axios from "axios";
import React, { useEffect, useState } from "react";
import { BsArrowLeft } from "react-icons/bs";
import { FaPen } from "react-icons/fa";
import { Link, useNavigate, useParams } from "react-router-dom";
import GallaryBox from "../../../Components/Global/GallaryBox";
import Loader from "../../../Components/Global/Loader";
import TablesList from "../../../Components/Global/TablesList";
import DashboardLayouts from "../../../Components/Layout/DashboardLayouts";
import { useAuth } from "../../../Context/AuthContext";

import useAuthentication from "../../../hooks/useAuthentication";
import useAxiosFetch from "../../../hooks/useAxiosFetch";
import useMultipleImgUpload from "../../../hooks/useMultipleImgUpload";
import useSearchListPagination from "../../../hooks/useSearchListPagination";
import useToastify from "../../../hooks/useToastify";

function BuildingDetails({ allowedRoles }) {
    // show toast hook 
  const { notify } = useToastify();

  const { allowLoading } = useAuthentication(allowedRoles);
  const {
    setisKeyPress,
    Count,
    setsearchKey,
    searchKey,
    setRecord,
    record,
    setPages,
    pages,
    totallength,
    paginationLoading,
    handleNextbtn,
    handlePrevbtn,
    PageShowFunc,
    SearchListApi,
    allData,
    responseData,
    callAnyApi,
  } = useSearchListPagination();

  const [loading, setLoading] = useState(false);
  const [buildingData, setBuildingData] = useState({});

  const [managerList, setManagerList] = useState({});
  const [showImage, setShowimage] = useState();
  const [viewImage, setViewImage] = useState([]);

  const value = useParams();
  const BuildId = value.id;
    // api api from global hook 

  const { axiosFetch} = useAxiosFetch();;
  const { designation } = useAuth();
const navigate= useNavigate()
  // ***** Building Image Show ********//



  // ***** Building Data Show ********//
  useEffect(() => {
    if (BuildId) {
      getBuildingValue();
    }
  }, [BuildId]);

  const getBuildingValue = () => {
    setLoading(true);

    axiosFetch({
      axiosInstance: axios,
      method: "GET",
      url: `/building/show/${BuildId}`,
    })
      .then((response) => {
        if (response?.data?.buildingDetails) {
          setBuildingData(response.data.buildingDetails?.[0]);

          if (response.data.buildingDetails?.[0]?.AssignBuildings) {
            let listData = [];
            response.data.buildingDetails?.[0]?.AssignBuildings.map((items) => {
              listData.push({
                email: items?.User?.email,
                Fname: items?.User?.first_name,
                Lname: items?.User?.last_name,
              });
              setManagerList(listData);
            });
          }
          

          
          const imgUrlMake = JSON.parse(
            response?.data?.buildingDetails?.[0]?.image
          )?.map((im) => ({ url: im }));
          setSelectedImages(imgUrlMake);
       
          setLoading(false);
        }
      })
      .catch((e) => {
        setLoading(false);
      });
  };
 

  useEffect(() => {
    callAnyApi(`/unit/list/${BuildId}`);
  }, [pages, record, searchKey,BuildId]);

  const {
    onSelectFile,
    deleteHandler,
    uploadToserver,
    selectedImages,
    setSelectedImages,
    defaultImg,
    setdefaultImg,
    handleDefaultImage,
    ImgLinks,
    setImgLinks,
  } = useMultipleImgUpload();

  const handleAddUnit=(item) => {

    if(managerList?.length > 0){

      navigate(`/add-units/${BuildId}`)
    }else{
      notify("there is no manager assigned to this building", "warning");
    }
  }
const [datasShow,setdatasShow]=useState([]);

const tableNameData = [
 
    
      "Sl No.",
      "Unit Name",
      "Unit Description",
     
      "Building Manager",
      "Tenant",
      "Type",
   
      "Status",
      "Action",
    
  
];
const tableValueData = 
  
  {
    
    value: [
      "unit_name",
      "unit_description",
     
      "managerName",
      "tenantName",
      "unit_type",
      // "InProgressSatus",
      "unitStatus",
    ],
    design: ["n", "n", "n", "n", "n"],
  };
    


  const onClickEditFunc=(item) => {
  

navigate( designation == "Owner" ||
designation == "Partner"
  ? `/add-units/${BuildId}?unitid=${item?.id}`
  : `/${designation?.toLowerCase()}/add-units/${BuildId}?unitid=${
      item?.id
    }`)
  }

useEffect(() => {
  const ggg = allData?.map((data, i) => ({
    ...data,
    unitStatus:data?.status, managerName:data?.managerId && `${data?.managerId?.first_name} ${
      data?.managerId?.middle_name !== null ? data?.managerId?.middle_name : ""
    } ${data?.managerId?.last_name}`,
    tenantName:data?.tenantId && `${data?.tenantId?.first_name} ${
      data?.tenantId?.middle_name !== null ? data?.tenantId?.middle_name : ""
    } ${data?.tenantId?.last_name}`,
   
  }));
  setdatasShow(ggg);
}, [allData, designation]);


  return (
    <>
      <DashboardLayouts>
        {(loading || allowLoading) && <Loader />}

        <div className="breadcrumb row justify-content-between align-items-center">
          <div className="d-flex align-items-center dashboard-upper-menu col-auto">
         

            <Link
             to={
              designation == "Owner" || designation == "Partner"
                ? `/buildinglist`
                : `/${designation?.toLowerCase()}/buildinglist`
            }
              className="d-flex align-items-center back-link"
            >
              <BsArrowLeft className="me-2 back-arrow m-0 " color="black" />
            </Link>
            <Link
             to={
              designation == "Owner" || designation == "Partner"
                ? `/dashboard`
                : `/${designation?.toLowerCase()}dashboard`
            }
              className="d-flex align-items-center back-link"
            >
              <i className="icon-dashboard"></i>
              <h3 className="mb-0 fw-normal">Dashboard</h3>
            </Link>
          </div>

          <div className="col-auto d-flex">
            {(designation == "Owner" || designation == "Partner") && (
              <Link
                to={`/addbuilding/${BuildId}`}
                className="btn btn-outline-primary me-2 d-flex align-items-center"
              >
                Edit <FaPen className="ms-3" />
              </Link>
            )}
            <Link
              to={
                designation == "Owner" || designation == "Partner"
                  ? `/buildinglist`
                  : `/${designation?.toLowerCase()}/buildinglist`
              }
              className="btn btn-outline-primary"
            >
              Back To Building List
            </Link>
          </div>
        </div>

        <div className="building-details2 row justify-content-between">
          <div className="col-12 col-xxl-7">
            <h1 className="heading-text">{buildingData?.buliding_name}</h1>
            <div className="row building-details-area">
            
             
                     
            <GallaryBox   selectedImages={selectedImages}  defaultImg={defaultImg} handleDefaultImage={handleDefaultImage} />

              <div className="col-md order-1 order-xl-2">
                <ul className="details">
                  <li className=" deails-text">
                    <h3>Building Code:</h3>
                    <p>{buildingData?.building_code}</p>
                  </li>
                  <li className=" deails-text">
                    <h3>Building Name:</h3>
                    <p>{buildingData?.building_name}</p>
                  </li>

                  <li className=" deails-text">
                    <h3>Address :</h3>
                    <p>
                      {buildingData?.apartment
                        ? buildingData?.apartment + ", "
                        : "" +
                          buildingData?.street_address +
                          ", " +
                          buildingData?.city +
                          ", " +
                          buildingData?.province_name +
                          ", " +
                          buildingData?.country_name +
                          ", " +
                          buildingData?.postal_code}
                    </p>
                  </li>

                  <li className="d-flex align-items-center justify-content-between justify-content-md-start">
                    <ul className="building-details-wrapper d-flex flex-wrap w-100 justify-between justify-content-md-start">
                      <li className=" list-info  me-md-5">
                        <span>City :</span>
                        <p>{buildingData?.city}</p>
                      </li>

                      <li className=" list-info me-md-5">
                        <span>Province :</span>
                        <p>{buildingData?.province_name}</p>
                      </li>

                      <li className=" list-info me-md-5">
                        <span>Country :</span>
                        <p>{buildingData?.country_name}</p>
                      </li>

                      <li className=" list-info">
                        <span>Post Code :</span>
                        <p>{buildingData?.postal_code}</p>
                      </li>
                    </ul>
                  </li>

                  <li className=" list-info">
                    <span>Description :</span>
                    <p>
                      {buildingData?.Description?.slice(0, 249)}
                      {buildingData?.Description?.length > 250 && "..."}
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="d-flex manager-list col-12 col-xxl-5 justify-content-xxl-end">
            <div className="list-scroll">
              <h3>Building Manager List</h3>
              <div className="building-list w-100">
                {managerList?.length > 0 ? (
                  <>
                    <ul className="list-data">
                      {managerList?.map((items, i) => {
                        return (
                          <li>
                            <h4>{items.Fname + " " + items.Lname}</h4>
                            <p>{items.email}</p>
                          </li>
                        );
                      })}
                    </ul>
                  </>
                ) : (
                  <p className="text-center py-4 text-gray-400">
                    No Building Manager List
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
        <hr className="w-100 line-2" />
        <div className="list-data">
            <div className="d-flex justify-content-between align-items-center mb-4 ">
              <h1 className="heading-text display-inline mt-3">All Units</h1>
              {(designation == "Owner" || designation == "Partner") && (
                <Link to={`/add-units/${BuildId}`}
                
                  className="btn btn-outline-primary "
                >
                  Add Unit
                </Link>
              )}
            </div>
            </div>
        <TablesList  
                isEditIconShow={true}
                // isDeleteIconShow={true}
                isViewIconShow={true}
                tableNameData={tableNameData}
                onClickEditFunc={onClickEditFunc}
                designation={designation} tableValueData={tableValueData} datasShow={datasShow}
                  setPages={setPages}  pages={pages}  record={record} setRecord={setRecord} setsearchKey={setsearchKey} setisKeyPress={setisKeyPress} searchKey={searchKey} SearchListApi={SearchListApi}
                  showTitle={false}
                
                title={"Unit"}  navigateUrl={"Unit"}  isSearchField={true}/>
      </DashboardLayouts>
    </>
  );
}

export default BuildingDetails;
